import ManageApplicationTypeTable from './ManageApplicationTypeTable'

const ManageApplicationType = {
  Table: ManageApplicationTypeTable,
}

export default ManageApplicationType
